import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShippingCostPage from "../pages/shipping-cost/page";
import CouponPage from "../pages/coupon/page";
import WarehousePage from "../pages/warehouse/page";
import LegitPage from "../pages/legit/page";
import BeginnerTipsPage from "../pages/beginner-tips/page";
import FindsPage from "../pages/finds/page";
import ReviewPage from "../pages/review/page";
import ShoppingStrategyPage from "../pages/shopping-strategy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <ShippingCostPage />,
  },
  {
    path: "/sugargoo-coupon",
    element: <CouponPage />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <WarehousePage />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <LegitPage />,
  },
  {
    path: "/sugargoo-beginner-tips",
    element: <BeginnerTipsPage />,
  },
  {
    path: "/sugargoo-spreadsheet-finds",
    element: <FindsPage />,
  },
  {
    path: "/sugargoo-review",
    element: <ReviewPage />,
  },
  {
    path: "/sugargoo-shopping-strategy",
    element: <ShoppingStrategyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;